/* eslint-disable */
/**
 * Auto-generated file. Do not edit manually. Run `yarn build:models` to regenerate.
 */

const modelMappings: Record<string, string> = {
  'face_landmark_68_tiny_model': '/models/face_landmark_68_tiny_model-3d0e8318bd1874a21015ff887f41c03f',
  'tiny_face_detector_model': '/models/tiny_face_detector_model-9499032ee06807904f86686070eef43a',
  'tfjs-backend-wasm': '/models/tfjs-backend-wasm-72a5ed4aab8999e7889369bf544c3cc9',
  'microblink-6-0-1': '/models/microblink-6-0-1-9f3870776964632feb811a9e786fdce0',
  'microblink-6-0-1-lightweight': '/models/microblink-6-0-1-lightweight-a8d380a5978d86845c9a0486a00095b0',
  'microblink-6-7-2': '/models/microblink-6-7-2-359ea93b70830a909cda35598a5ccf06',
  'custom-1': '/models/custom-1-14137abb6fc1215040f1dd2c9b9a61d7'
};

export default modelMappings;
